import * as types from "containers/classDetail/ActionType.js";

const initialState = {
    isFnshoModalIsOpen: false,
};

export const changeIsFnshoModalIsOpen = (status) => ({ type: types.IS_FNSHO_MODAL_IS_OPEN, status });

export default function classDetailReducer(state = initialState, action) {
    switch (action.type) {
        case types.IS_FNSHO_MODAL_IS_OPEN:
            return {
                ...state,
                isFnshoModalIsOpen: action.status,
            };
        default:
            return { ...state }
    }
};